import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { withRouter, Link } from 'react-router-dom'

const styles = {
  card: {
    maxWidth: 345
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  }
}

class EmailCard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: 'GENERATE',
      percentage: ''
    }
  }

  generatePolicy () {
    alert('Email Policy Generated')
    this.setState({ message: 'POLICY GENERATED' })
  }

  render () {
    const { classes } = this.props
    const { fields } = this.props
    return (
      <div>
        <Card className={classes.card}>
          <CardMedia
            className={classes.media}
            image={`../img/${fields.img}`}
          />
          <CardContent>
            <Typography gutterBottom variant='headline' component='h2'>
              {this.props.name}
            </Typography>
            <hr />
            <Typography component='p'>
              {fields.progress}
            </Typography>
            <hr />
            <Typography component='p'>
              {fields.description}
            </Typography>
          </CardContent>
          <CardActions>
            {/* <Button size="small" color="primary" onClick={() => { this.generatePolicy() }}>
                            {this.state.message}
                        </Button> */}
            <Link to={`/app/policies/${fields.questionnaire}`}>
              <Button size='small' color='primary'>
                                Generate
              </Button>
            </Link>
            <Button size='small' color='primary'>
                            Upload
            </Button>
            <Link to={`/app/policies/${fields.template}`}>
              <Button size='small' color='primary'>
                                View
              </Button>
            </Link>
          </CardActions>
        </Card>
      </div>
    )
  }
}
EmailCard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withRouter(EmailCard))



// WEBPACK FOOTER //
// ./src/components/policies/components/Card.js